'use client';

import { MarketPlaceEntryPoint } from '@/components/entry-points/MarketPlaceEntryPoint';
import { CognitoUser } from '@/lib/schema/user/types';
import '@/styles/globals.css';
import { PropsWithChildren } from 'react';

type AppWrapperProps = PropsWithChildren<{
  noHeader?: boolean;
  noFooter?: boolean;
  user?: CognitoUser | null;
}>;

export default function AppWrapper({
  children,
  noHeader = false,
  noFooter = false,
  user = null,
}: AppWrapperProps) {
  return (
    <MarketPlaceEntryPoint noHeader={noHeader} noFooter={noFooter} user={user}>
      {children}
    </MarketPlaceEntryPoint>
  );
}
